type AsyncCallback = () => void

export default function (asyncCallback: AsyncCallback) {
  (async () => {
    await asyncCallback()
  })()
}
